import { useState } from "react";
import "./CarRentals.css";

export default function CarRentals() {
  const [showForm, setShowForm] = useState(false);
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    car: "",
    pickupDate: "",
    returnDate: "",
    message: "",
  });

  const whatsappNumber = "+255718665620";

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const nextStep = () => setStep(step + 1);
  const prevStep = () => setStep(step - 1);

  const onSubmit = (e) => {
    e.preventDefault();
    const text = `🚗 *Car Booking Request* 🚗
Name: ${form.name}
Email: ${form.email}
Phone: ${form.phone}
Car Model: ${form.car}
Pickup Date: ${form.pickupDate}
Return Date: ${form.returnDate}
Message: ${form.message}`;

    const sanitizedNumber = whatsappNumber.replace(/\D/g, "");
    const url = `https://wa.me/${sanitizedNumber}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");

    setForm({
      name: "",
      email: "",
      phone: "",
      car: "",
      pickupDate: "",
      returnDate: "",
      message: "",
    });
    setStep(1);
    setShowForm(false);
  };

  const selectCar = (carName) => {
    setForm({ ...form, car: carName });
    setShowForm(true);
    setStep(2);
  };

  return (
    <section className="car-rentals">
      <header
        className="hero"
        style={{ backgroundImage: "url(/images/carrent.webp)" }}
      >
        <div className="overlay">
          <h1>CAR RENTALS</h1>
          <p>Premium fleet for your Zanzibar adventure. Self-drive or chauffeured options available.</p>
          <button className="btn-primary" onClick={() => setShowForm(true)}>Book Your Car</button>
        </div>
      </header>

      <div className="rental-grid">
        <div className="rental-card">
          <h3>Economy</h3>
          <p>Fuel-efficient cars for solo travelers & couples.</p>
        </div>
        <div className="rental-card">
          <h3>SUV</h3>
          <p>Comfortable SUVs perfect for families & safaris.</p>
        </div>
        <div className="rental-card">
          <h3>Minivan</h3>
          <p>Spacious & luggage-friendly for groups.</p>
        </div>
      </div>

      <section className="gallery">
        <h2>OUR FLEET</h2>
        <div className="gallery-grid">
          {[
            { name: "TOYOTA RAV4 5 DOORS", img: "/images/rava5.jpg" },
            { name: "TOYOTA RAV4 3 DOORS", img: "/images/rava3.jpg" },
            { name: "SUZUKI GRAND VITARA", img: "/images/suzukivitara.jpg" },
            { name: "SUZUKI ESCUDO 5 DOORS", img: "/images/suzukiescudo.jpg" },
            { name: "SUZUKI ESCUDO 3 DOORS", img: "/images/suzukiescudo3.jpg" },
            { name: "TOYOTA NOAH", img: "/images/toyotanoah.jpg" },
          ].map((car, i) => (
            <div key={i} className="gallery-item" onClick={() => selectCar(car.name)}>
              <img src={car.img} alt={car.name} />
              <span className="car-name">{car.name}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Booking Form Modal */}
      {showForm && (
        <div className="booking-form-overlay">
          <div className="booking-form">
            <h3>Book Your Car</h3>
            <form onSubmit={onSubmit}>
              {step === 1 && (
                <>
                  <div className="floating-label">
                    <input type="text" name="name" value={form.name} onChange={onChange} required />
                    <label>Name</label>
                  </div>
                  <div className="floating-label">
                    <input type="email" name="email" value={form.email} onChange={onChange} required />
                    <label>Email</label>
                  </div>
                  <div className="floating-label">
                    <input type="text" name="phone" value={form.phone} onChange={onChange} required />
                    <label>Phone</label>
                  </div>
                  <div className="form-actions">
                    <button type="button" className="btn-primary" onClick={nextStep}>Next</button>
                    <button type="button" className="btn-secondary" onClick={() => setShowForm(false)}>Cancel</button>
                  </div>
                </>
              )}

              {step === 2 && (
                <>
                  <div className="floating-label">
                    <select name="car" value={form.car} onChange={onChange} required>
                      <option value="">Select Car Model</option>
                      <option>TOYOTA RAV4 5 DOORS</option>
                      <option>TOYOTA RAV4 3 DOORS</option>
                      <option>SUZUKI GRAND VITARA</option>
                      <option>SUZUKI ESCUDO 5 DOORS</option>
                      <option>SUZUKI ESCUDO 3 DOORS</option>
                      <option>TOYOTA NOAH</option>
                    </select>
                    <label>Car Model</label>
                  </div>
                  <div className="floating-label">
                    <input type="date" name="pickupDate" value={form.pickupDate} onChange={onChange} required />
                    <label>Pickup Date</label>
                  </div>
                  <div className="floating-label">
                    <input type="date" name="returnDate" value={form.returnDate} onChange={onChange} required />
                    <label>Return Date</label>
                  </div>
                  <div className="form-actions">
                    <button type="button" className="btn-secondary" onClick={prevStep}>Back</button>
                    <button type="button" className="btn-primary" onClick={nextStep}>Next</button>
                  </div>
                </>
              )}

              {step === 3 && (
                <>
                  <div className="floating-label">
                    <textarea name="message" value={form.message} onChange={onChange} rows="4" />
                    <label>Message (Optional)</label>
                  </div>
                  <div className="form-actions">
                    <button type="button" className="btn-secondary" onClick={prevStep}>Back</button>
                    <button type="submit" className="btn-primary">Send via WhatsApp</button>
                  </div>
                </>
              )}
            </form>
          </div>
        </div>
      )}
    </section>
  );
}
